export default __webpack_public_path__ + "static/media/final_image.9d11e546.png";